module.exports = __webpack_public_path__ + "static/assets/49155458334f57d91193a2a347c23311.png";